export default __webpack_public_path__ + "images/GOTLAND.6d8b436.png";